module.exports = __webpack_public_path__ + "static/media/my-passes.af110556.svg";